import { useState } from 'react'
import {
    getSelectedTicketsForReleaseFromStorage,
    removeSelectedTicketsForReleaseFromStorage,
    setSelectedTicketsForReleaseToStorage,
} from 'utils/sessionStorage'

export const useSelectedSeatsRelease = (eventId: string) => {
    const initialTickets = getSelectedTicketsForReleaseFromStorage(eventId)

    const [selectedSeats, setSelectedSeats] = useState<string[]>(initialTickets)

    const changeSelectedSeats = (updatedTickets: string[]) => {
        setSelectedTicketsForReleaseToStorage(updatedTickets, eventId)
        setSelectedSeats(updatedTickets)
    }

    const clearSelectedSeats = () => {
        removeSelectedTicketsForReleaseFromStorage(eventId)
        setSelectedSeats([])
    }

    return { selectedSeats, changeSelectedSeats, clearSelectedSeats }
}
